import { vigilkidsConfig } from './vigilkids'
import { createVisivaConfig } from './visiva'

import type { BrandConfig } from '@checkout/themes'

/** 品牌注册表 */
const brandFactories: Record<string, () => BrandConfig> = {
  vigilkids: () => vigilkidsConfig,
  visiva: createVisivaConfig,
}

/**
 * 获取品牌配置
 * @param brandId 品牌 ID
 * @returns 品牌配置
 * @throws 如果品牌不存在
 */
export function getBrandConfig(brandId: string): BrandConfig {
  const createConfig = brandFactories[brandId]
  if (!createConfig) {
    throw new Error(
      `Unknown brand: "${brandId}". Available brands: ${Object.keys(brandFactories).join(', ')}`
    )
  }
  return createConfig()
}

/**
 * 获取所有品牌 ID
 */
export function getAllBrandIds(): string[] {
  return Object.keys(brandFactories)
}

/**
 * 检查品牌是否存在
 */
export function hasBrand(brandId: string): boolean {
  return brandId in brandFactories
}

// 导出类型
export type { BrandConfig, BrandTheme, PaymentMethodType } from './types'

// 导出品牌配置
export { vigilkidsConfig } from './vigilkids'
export { createVisivaConfig } from './visiva'
